import { observer } from 'mobx-react'

import PromoteFlow from 'modules/contracts/components/PromoteFlow'
import RequestPromoteFlow from 'modules/contracts/components/RequestPromoteFlow'
import { useHasToRequestPromotion } from 'modules/contracts/hooks/useHasToRequestPromotion'
import Loading from 'modules/layout/components/Page/Loading'

const RequestOrPromote = () => {
  const { loading, hasToRequestPromotion } = useHasToRequestPromotion()

  if (loading) {
    return <Loading />
  }

  if (hasToRequestPromotion) {
    return <RequestPromoteFlow />
  }

  return <PromoteFlow />
}

export default observer(RequestOrPromote)
